import { api_get, api_post } from "./utils"

const MutualAPI = {
    // load: _loadMutual,
    list: _loadMutualList,
    listed: _loadMutualListed,
    create: _createMutual,
    remove: _removeMutual,
    setMutualStatus: _setMutualStatus,
};


// async function _loadMutual(key: string) {
//     // Autogenerated
//     if (!key) {
//         return null;
//     }
//     return api_get("/mutual/" + key).then((res) => {
//         if (!res.ok) {
//             return null;
//         }
//         else {
//             return res.json();
//         }
//     });
// }


async function _loadMutualList(identityKey="", cursor="") {
    const url = '/mutual/list';
    return api_get(url, {identity: identityKey, cursor: cursor})
        .then((res) => {
            if (!res.ok) {
                return null;
            }
        else {
            return res.json();
        }
        });
}




async function _loadMutualListed(identityKey="", cursor="") {
    const url = '/mutual/listed';
    return api_get(url, {identity: identityKey, cursor: cursor})
        .then((res) => {
            if (!res.ok) {
                return null;
            }
        else {
            return res.json();
        }
        });
}

async function _createMutual(identityKey="", mutualIdentityKey="") {
    return api_post('/mutual/create',
        {
            identity: identityKey,
            mutual_identity: mutualIdentityKey
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}


async function _removeMutual(identityKey="", mutualIdentityKey="") {
    return api_post('/mutual/remove',
        {
            identity: identityKey,
            mutual_identity: mutualIdentityKey
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}


async function _setMutualStatus(identityKey="", mutualIdentityKey="", status="") {
    return api_post('/mutual/set-mutual-status',
        {
            identity: identityKey,
            mutual_identity: mutualIdentityKey,
            mutual_status: status
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

export default MutualAPI;
